/**
 * 판매자 센터 주소 → 세모 본 사이트 주소. 판매자 센터는 씨마켓 임베드(토큰)로만 열려서,
 * 주소창으로 들어온 사람은 본 사이트의 «공급기업 가입»·«씨마켓 로그인»으로 안내한다.
 *   staging-vendor.semo.io.kr → staging.semo.io.kr · dev-vendor.… → dev.… · vendor.semo.io.kr → semo.io.kr
 *   그 밖(로컬 등) → 같은 호스트의 3000번
 */
export function mainSiteOrigin(loc: {
  protocol: string;
  hostname: string;
}): string {
  const m = /^([a-z0-9-]+-)?vendor\.(.+)$/u.exec(loc.hostname);
  if (m) {
    const env = m[1] ? m[1].slice(0, -1) : "";
    return `${loc.protocol}//${env ? `${env}.` : ""}${m[2] ?? ""}`;
  }
  return `${loc.protocol}//${loc.hostname}:3000`;
}

export const CMARKET_LOGIN_URL = "https://www.c-market.net";
